<template>
  <div class="closd-lang-selector">
    <AppSelect
      :model-value="$i18n.locale"
      item-title="code"
      item-value="code"
      color="blue-darken-2"
      :items="languages"
      density="comfortable"
      no-label
      @update:model-value="localeChanged"
    >
      <template #selection="{ item }">
        <div class="d-flex align-center ga-2">
          <img :src="item.raw.urlSvg" class="flag" alt="available language">
          <span>{{ $t(`common.languages.names.${item.value}`)}} ({{ item.value.toUpperCase() }})</span>
        </div>
      </template>
      <template #item="{ item, props }">
        <v-list-item class="closd-lang-selector__menu-item" v-bind="props">
          <template #title>
            <div class="d-flex align-center ga-2">
              <img :src="item.raw.urlSvg" class="flag" alt="available language">
              <span>{{ $t(`common.languages.names.${item.value}`)}} ({{ item.value.toUpperCase() }})</span>
            </div>
          </template>
        </v-list-item>
      </template>
    </AppSelect>
  </div>
</template>

<script>
import AppSelect from '@/common/AppSelect.vue'
import { countryFlags } from '@/common/assets'

/**
 * Default lang selector
 * @displayName ClosdLangSelector
 */

/**
 * Display a select with lang choice
 */
export default {
  name: 'ClosdLangSelector',
  components: { AppSelect },
  data () {
    return {
      languages: [
        { code: 'fr', urlSvg: countryFlags.fr },
        { code: 'en', urlSvg: countryFlags.en },
        { code: 'de', urlSvg: countryFlags.de },
        { code: 'es', urlSvg: countryFlags.es },
      ],
    }
  },
  methods: {
    /**
     * Gets called when the user change select value
     *
     * @param {String} newLocale The new lang selected
     */
    localeChanged (newLocale) {
      this.$i18n.locale = newLocale
      this.$router.replace({ ...this.$route, params: { locale: newLocale } })
    },
  },
}
</script>

<style lang="scss" scoped>
.closd-lang-selector {
  &__menu-item {
    display: flex;
    justify-content: start;
  }
  :deep(.v-field__append-inner) {
    padding-right: 4px !important;
  }
  :deep(.v-select) {
    display: flex;
  }
}

.flag{
  width: 20px;
  height: 15px;
}
</style>
